module.exports = __webpack_public_path__ + "img/DROP.cad2fdb1.svg";